import { observer } from 'mobx-react'
import React, { Component } from 'react'
import lang from '../../stores/lang'

const options = {
  gender: [
    'MALE',
    'FEMALE',
  ],
  diagnosis: [
    'OPEN_ANGLE',
    'ANGLE_CLOSURE',
    'NEOVASCULAR',
    'NORMAL_TENSION',
    'OCULAR_HYPERTENSION',
    'PIGMENTARY',
    'PSEUDOEXFOLIATION',
    'STEROID_RESPONSE',
    'SUSPECT',
    'TRAUMATIC',
    'UVEITIC',
  ],
  ethnicity: [
    'AMERICAN_INDIAN_ALASKA_NATIVE',
    'BLACK_AFRICAN_AMERICAN',
    'EAST_ASIAN',
    'HISPANIC_LATINO',
    'MIDDLE_EASTERN_NORTH_AFRICAN',
    'NATIVE_HAWAIIAN_PACIFIC_ISLANDER',
    'SOUTH_ASIAN',
    'WHITE',
    'OPT_OUT',
  ],
  eye: [
    'BOTH',
    'LEFT',
    'RIGHT',
  ],
  yesNo: [
    'YES',
    'NO',
  ],
  socialSupport: [
    'DAUGHTER',
    'FRIEND',
    'INDEPENDENT',
    'OTHER',
    'SON',
    'SPOUSE',
  ],
  location: [
    'OTHER',
    'BEDSIDE',
    'BEDROOM_VANITY',
    'BATHROOM',
    'KITCHEN',
    'CAR',
    'OFFICE_DESK',
    'ON_PERSON',
    'LIVING_ROOM',
  ],
  purpleMedication: [
    'ALPHAGAN',
    'APRACLONIDINE',
    'BRIMONIDINE',
    'IOPIDINE',
  ],
  orangeMedication: [
    'AZOPT',
    'DORZOLAMIDE',
  ],
  darkBlueMedication: [
    'COMBIGAN_BRIMONIDINE_TIMOLOL',
    'COSOPT',
    'COSOPT_PF',
    'DORZOLAMIDE_TIMOLOL',
  ],
  darkGreenMedication: [
    'AKARPINE',
    'ISOPTO_CARBACHOL',
    'ISOPTO_CARPINE',
    'PHOSPHOLINE_IODIDE',
    'PILOCAR',
    'PILOCARPINE',
    'PILOPTIC',
  ],
  tealMedication: [
    'BIMATOPROST',
    'LATANOPROST',
    'LUMIGAN',
    'TAFLUPROST_PF',
    'TRAVAPROST',
    'TRAVATAN',
    'VYZULTA',
    'XALATAN',
    'ZIOPTAN_PF',
  ],
  yellowMedication: [
    'AK_BETA',
    'BETAXOLOL',
    'BETIMOL',
    'BETOPTIC',
    'CARTEOLOL',
    'ISTALOL',
    'LEVOBUNOLOL',
    'METIPRANOLOL',
    'OCUPRESS',
    'OPTIPRANOLOL',
    'TIMOLOL',
    'TIMOPTIC',
    'TIMOPTIC_OCUDOSE_PF',
  ],
  whiteMedication: [
    'RHOPRESSA', // Added June 2021
    'ROCKLATAN', // Added June 2021
  ],
  otherMedication: [
    'ANTIBIOTIC_DROPS',
    // 'ARTIFICIAL_TEARS', // Removed June 2021
    // 'DILATING_DROPS', // Removed June 2021
    'NONSTEROIDAL_ANTI_INFLAMMATORY_DROPS',
    'OPHTHALMIC_OINTMENT',
    'RESTASIS',
    'SIMBRINZA',
    'STEROID_DROPS',
  ],
  oct: [
    'GREEN',
    'YELLOW',
    'RED',
  ],
  providerLocation: [
    'KELLOGG_EYE_CENTER',
    'HAMILTON_CLINIC',
    'HOPE_CLINIC',
    'OTHER',
  ],
  month: [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ],
  lowVision: [
    'YES',
    'NO',
  ],
}

@observer
export default class Options extends Component {
  renderOptions() {
    const { choices, disabledChoices = [] } = this.props
    // This means it's passing an array most likely fetched from backend, monitor id for example
    const noTranslation = Array.isArray(choices)
    // Doing this because I'm lazy and short on time, but there are obviously better ways to fix
    // this problem.
    let choicesKeyPrefix = ''
    if(typeof choices === 'string') {
      if (choices.endsWith('Medication')) {
        choicesKeyPrefix = 'choices.medication'
      } else {
        choicesKeyPrefix = `choices.${choices}`
      }
    }

    if(Array.isArray(options[choices])) {
      return options[choices].map((v, i) => (
        <option key={i} value={v} disabled={disabledChoices.includes(v)}>
          {noTranslation? v: lang.translate(`${choicesKeyPrefix}.${v}`)}
        </option>
      ))
    } else if(Array.isArray(choices)) {
      return choices.map((v, i) => (
        <option key={i} value={v} disabled={disabledChoices.includes(v)}>
          {noTranslation? v: lang.translate(`${choicesKeyPrefix}.${v}`)}
        </option>
      ))
    }
    return null;
  }

  render() {
    const { label } = this.props

    if (label) {
      return (
        <optgroup label={lang.translate(label)}>
          {this.renderOptions()}
        </optgroup>
      )
    }

    return this.renderOptions()
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/Options.js